export function create(x: number, y = 1) {
	var count = x * y;
	var output = [];
	for (var i = 0; i < count; i++) {
		output.push(0);
	}
	return output;
}

export function multiply_3x3(A: number[], B: number[]) {
	var m1_0 = A[0],
		m1_1 = A[1],
		m1_2 = A[2];
	var m1_3 = A[3],
		m1_4 = A[4],
		m1_5 = A[5];
	var m1_6 = A[6],
		m1_7 = A[7],
		m1_8 = A[8];

	var m2_0 = B[0],
		m2_1 = B[1],
		m2_2 = B[2];
	var m2_3 = B[3],
		m2_4 = B[4],
		m2_5 = B[5];
	var m2_6 = B[6],
		m2_7 = B[7],
		m2_8 = B[8];

	var C = [];
	C[0] = m1_0 * m2_0 + m1_1 * m2_3 + m1_2 * m2_6;
	C[1] = m1_0 * m2_1 + m1_1 * m2_4 + m1_2 * m2_7;
	C[2] = m1_0 * m2_2 + m1_1 * m2_5 + m1_2 * m2_8;
	C[3] = m1_3 * m2_0 + m1_4 * m2_3 + m1_5 * m2_6;
	C[4] = m1_3 * m2_1 + m1_4 * m2_4 + m1_5 * m2_7;
	C[5] = m1_3 * m2_2 + m1_4 * m2_5 + m1_5 * m2_8;
	C[6] = m1_6 * m2_0 + m1_7 * m2_3 + m1_8 * m2_6;
	C[7] = m1_6 * m2_1 + m1_7 * m2_4 + m1_8 * m2_7;
	C[8] = m1_6 * m2_2 + m1_7 * m2_5 + m1_8 * m2_8;

	return C;
}

export function createRotationMatrix(x: number, y: number, z: number) {
	return multiply_3x3(RotX(x), multiply_3x3(RotY(y), RotZ(z)));
}

function RotX(x: number) {
	var r = create(3, 3);
	r[0] = 1;
	r[4] = r[8] = Math.cos(x);
	r[7] = Math.sin(x);
	r[5] = -r[7];
	return r;
}

function RotY(y: number) {
	var r = create(3, 3);
	r[4] = 1;
	r[0] = r[8] = Math.cos(y);
	r[2] = Math.sin(y);
	r[6] = -r[2];
	return r;
}

function RotZ(z: number) {
	var r = create(3, 3);
	r[8] = 1;
	r[4] = r[0] = Math.cos(z);
	r[3] = Math.sin(z);
	r[1] = -r[3];
	return r;
}
